import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-020324aa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "body" }

import {ComponentPublicInstance, ref, watch} from 'vue';
import {createCrudTableService} from './service/CrudTableService';
import WidgetTablePagination from "@/components/business/crud/table/WidgetTablePagination.vue";
import WidgetTableButton from "@/components/business/crud/table/WidgetTableButton.vue";
import WidgetTableBody from "@/components/business/crud/table/WidgetTableBody.vue";
import {bindRef, useQueryParam} from "@/util/queryParam";
import WidgetSearch from "@/components/business/crud/form/WidgetSearch.vue";
import {createSearchService} from "@/components/business/crud/service/CrudSearchService";
import _ from "lodash";
import WidgetSearchBtn from '@/components/business/crud/form/WidgetSearchBtn.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'CrudTable',
  props: {
    moduleName: {},
    controllerName: {}
  },
  setup(__props: any) {

const props = __props;
const showSearch = ref(false)
const searchService = createSearchService(props.moduleName, props.controllerName);
const {form, groups, getCondition} = searchService.use();
const tableService = createCrudTableService(props.moduleName, props.controllerName);
const {
  schema,
  columns,
  listData,
  rowSelection,
  onChange,
  buttons,
} = tableService.use();

const searchData = useQueryParam("searchData");
const readonlyFields = useQueryParam("readonlyFields");

/**
 * 查询时候修改列表查询条件，将查询数据同步到url上
 */
function onSearch() {
  tableService.listConfig.condition = getCondition();
  searchData.value = _.cloneDeep(form.data.value);
}

let isInit = false;

const queryParam = useQueryParam("table");
searchService
    .init()
    .then(() => {
      /**
       * 监听url数据，来修改查询表单数据
       */
      watch(searchData, () => {
        const queryValue = searchData.value || {};
        if (!_.isEqual(queryValue, form.data.value)) {
          form.data.value = queryValue;
        }
      }, {deep: true, immediate: true});
      /**
       * 监听url数据，来设置查询表单只读字段
       * todo 双向绑定
       */
      watch(() => readonlyFields, () => {
        if (readonlyFields.value) {
          searchService.setReadonlyFields(readonlyFields.value);
          if (isInit) {
            onSearch();
          }
        }
      }, {deep: true, immediate: true})
      /**
       * 监听url数据，来修改列表排序字段
       * todo 双向绑定
       */
      watch(() => queryParam.value?.orderBy, () => {
        onChange(undefined, undefined, queryParam.value?.orderBy || []);
      }, {deep: true, immediate: true})
      if (!isInit) {
        isInit = true;
        onSearch();
      }
      tableService.init()
    });


const table = ref<ComponentPublicInstance>();

function backTopTarget() {
  return table.value?.$el;
}


return (_ctx: any,_cache: any) => {
  const _component_a_back_top = _resolveComponent("a-back-top")!
  const _component_sc_page = _resolveComponent("sc-page")!

  return (_openBlock(), _createBlock(_component_sc_page, {
    title: _unref(schema).title,
    desc: _unref(schema).desc,
    ref_key: "table",
    ref: table
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(WidgetSearch, {
          form: _unref(form),
          groups: _unref(groups),
          onSearch: onSearch,
          show: showSearch.value
        }, null, 8, ["form", "groups", "show"]),
        _createVNode(WidgetTableButton, { buttons: _unref(buttons) }, {
          default: _withCtx(() => [
            _createVNode(WidgetSearchBtn, {
              modelValue: showSearch.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((showSearch).value = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }, 8, ["buttons"]),
        _createVNode(WidgetTableBody, {
          onChange: _unref(onChange),
          "list-data": _unref(listData),
          columns: _unref(columns),
          "row-selection": _unref(rowSelection),
          "select-row-key": _unref(schema).primary
        }, null, 8, ["onChange", "list-data", "columns", "row-selection", "select-row-key"]),
        _createVNode(WidgetTablePagination, {
          count: _unref(listData).count,
          "page-num": _unref(tableService).listConfig.pageNum,
          "onUpdate:pageNum": _cache[1] || (_cache[1] = ($event: any) => ((_unref(tableService).listConfig.pageNum) = $event)),
          "page-size": _unref(tableService).listConfig.pageSize,
          "onUpdate:pageSize": _cache[2] || (_cache[2] = ($event: any) => ((_unref(tableService).listConfig.pageSize) = $event))
        }, null, 8, ["count", "page-num", "page-size"]),
        _createVNode(_component_a_back_top, {
          target: backTopTarget,
          visibilityHeight: 100
        })
      ])
    ]),
    _: 1
  }, 8, ["title", "desc"]))
}
}

})